import { setProperty } from '.';

let userId: string | undefined;

export const getUserId = (): string | undefined => userId;

export function setUserId(newUserId: string | undefined): void {
	userId = newUserId;

	setProperty({ name: 'user_properties', payload: { user_id: userId } });
}
